import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import NProgress from 'nprogress'
import * as d3 from "d3";
import GoogleAnalytics from 'react-ga';

import PlayButton from './PlayButton'

import Notification from '../services/Notification.js'
import Train from '../services/train.js';
import Element from '../services/Element.js';

import '../../css/Treemap.css';

let transitioning, viewObject;

class Treemap extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }

    this.headerHeight = 50;
    this.playerHeight = 60;
    this.treemapHeaderHeight = 50;
    this.playerShown = false;

  }


  componentDidMount() {
    this.fetchData();
    this.eventHandler = this.updateDimensions.bind(this);
    window.addEventListener("resize", this.eventHandler);

  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.eventHandler);
  }

  updateDimensions() {
    if (this.state.treemapData)
      this.renderPacks(this.state.treemapData);

  }

  getWidth() {
    let width = document.getElementById('App').offsetWidth;
    return width;
  }

  getHeight() {
    let height = (document.getElementById('App').offsetHeight - this.treemapHeaderHeight - this.headerHeight - this.playerHeight);
    return height;
  }

  treemapElement() {
    let element = {};
    element[this.treemapContext()] = this.treemapSearchTerm();
    return element;
  }

  treemapSearchTerm() {
    return this.props.match.params.searchTerm;
  }

  treemapContext() {
    return this.props.match.params.context;
  }

  treemapType() {
    return this.props.match.params.treemapType;
  }

  treemapTypeTerm() {
    return this.props.match.params.treemapTypeTerm || '';
  }

  fetchData() {

    GoogleAnalytics.event({
      category: 'TreeMap',
      action: 'loaded',
      label: this.props.location.pathname
    });

    NProgress.start();

    let queryParams = new URLSearchParams(this.props.location.search);

    let period = queryParams.get('period');
    let discovered = queryParams.get('discovered');
    let loved = queryParams.get('loved');
    let sort = queryParams.get('sort');


    Train.fetchTreemapData({
      context: this.treemapContext(), 
      searchTerm: this.treemapSearchTerm(), 
      treemapType: this.treemapType(), 
      treemapTypeTerm: this.treemapTypeTerm(),
      period,
      discovered,
      loved,
      sort
    })
    .then((data) => {

      NProgress.done();

      if (!data.children) {
        Notification.show('Not enough data was found for the requested treemap', 'warning');
      } else {
        this.setState({treemapData: data});
        this.renderPacks(data);
      }

    })
    .catch((e) => {
      NProgress.done();
      Notification.show('Error loading tree map data', 'error');
    });

  }

  renderPacks(data) {

    if (!data)
      return;

    data = JSON.parse(JSON.stringify(data));

    if (this.refs.treemap)
      d3.select(this.refs.treemap).html('');

    let formatNumber = d3.format(",d");

    let root = data;
    viewObject = root;

    let color = d3.scale.category20c();

    let width = this.getWidth();
    let height = this.getHeight();

    let margin = {top: this.headerHeight, right: 0, bottom: 0, left: 0};

    let x = d3.scale.linear()
        .domain([0, width])
        .range([0, width]);

    let y = d3.scale.linear()
        .domain([0, height])
        .range([0, height]);

    let treemap = d3.layout.treemap()
        .children(function(d, depth) { return depth ? null : d._children; })
        .sort(function(a, b) { return a.value - b.value; })
        .ratio(height / width * 0.5 * (1 + Math.sqrt(5)))
        .round(false);


    let svg = d3.select(this.refs.treemap)
        .attr("width", width)
        .attr("height", height + this.treemapHeaderHeight)
        .style("margin-top", margin.top + "px")
        .style("margin-left", -margin.left + "px")
        .style("margin.right", -margin.right + "px")
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        .style("shape-rendering", "crispEdges");

    let grandparent = svg.append("g")
        .attr("class", "grandparent");

    grandparent.append("rect")
        .attr("y", -margin.top)
        .attr("width", width)
        .attr("height", margin.top);

    grandparent.append("text")
        .attr("x", 12)
        .attr("y", 12 - margin.top)
        .attr("dy", ".75em");

    let name = (d) => {
      let title = d.name;
      let isRoot = root === viewObject;

      if (d.name !== this.state.title) {
        this.setState({title, isRoot, currentNode: viewObject});  
      }
    }

    initialize(root);
    accumulate(root);
    layout(root);
    display(root);

    function initialize(root) {
      root.x = root.y = 0;
      root.dx = width;
      root.dy = height;
      root.depth = 0;
    }

    // Aggregate the values for internal nodes. This is normally done by the
    // treemap layout, but not here because of our custom implementation.
    // We also take a snapshot of the original children (_children) to avoid
    // the children being overwritten when when layout is computed.
    function accumulate(d) {
      d._children = d.children;
      return (d.children)
          ? d.value = d.children.reduce(function(p, v) { return p + accumulate(v); }, 0)
          : d.value;
    }

    // Compute the treemap layout recursively such that each group of siblings
    // uses the same size (1×1) rather than the dimensions of the parent cell.
    // This optimizes the layout for the current zoom state. Note that a wrapper
    // object is created for the parent node for each group of siblings so that
    // the parent’s dimensions are not discarded as we recurse. Since each group
    // of sibling was laid out in 1×1, we must rescale to fit using absolute
    // coordinates. This lets us use a viewport to zoom.
    function layout(d) {
      if (d._children) {
        treemap.nodes({_children: d._children});
        d._children.forEach(function(c) {
          c.x = d.x + c.x * d.dx;
          c.y = d.y + c.y * d.dy;
          c.dx *= d.dx;
          c.dy *= d.dy;
          c.parent = d;
          layout(c);
        });
      }
    }

    function display(d) {
      grandparent
          .datum(d.parent)
          .on("click", transition)
        .select("text")
          .text(name(d));

      let g1 = svg.insert("g", ".grandparent")
          .datum(d)
          .attr("class", "depth");

      let g = g1.selectAll("g")
          .data(d._children)
        .enter().append("g");

      g.filter(function(d) { return d._children; })
          .classed("children", true)
          .on("click", transition);

      g.selectAll(".child")
          .data(function(d) { return d._children || [d]; })
        .enter().append("rect")
          .attr("class", "child")
          .call(rect);

      g.append("rect")
          .attr("class", "parent")
          .call(rect)
          .style("fill", function(d) { return color(d.name); })
        .append("title")
          .text(function(d) { return d.name + ': ' + formatNumber(d.value); });

      g.append("text")
          .attr("dy", ".75em")
          .text(function(d) { if (viewObject === root) { if (d.dy > 20) return d.name.slice(0,d.dx/8.5); else return ''; } else return d.name; } )
          .call(text);

      d3.select(window).on("click", function(){transition(root)});

      function transition(d) {
        if (transitioning || !d) return;
        transitioning = true;

        viewObject = d;

        let g2 = display(d),
            t1 = g1.transition().duration(750),
            t2 = g2.transition().duration(750);

        // Update the domain only after entering new elements.
        x.domain([d.x, d.x + d.dx]);
        y.domain([d.y, d.y + d.dy]);

        // Enable anti-aliasing during the transition.
        svg.style("shape-rendering", null);

        // Draw child nodes on top of parent nodes.
        svg.selectAll(".depth").sort(function(a, b) { return a.depth - b.depth; });

        // Fade-in entering text.
        g2.selectAll("text").style("fill-opacity", 0);

        // Transition to the new view.
        t1.selectAll("text").call(text).style("fill-opacity", 0);
        t2.selectAll("text").call(text).style("fill-opacity", 1);
        t1.selectAll("rect").call(rect);
        t2.selectAll("rect").call(rect);

        // Remove the old node when the transition is finished.
        t1.remove().each("end", function() {
          svg.style("shape-rendering", "crispEdges");
          transitioning = false;
        });
      }

      

      return g;
    }

    function text(text) {
      text.attr("x", function(d) { return x(d.x) + 6; })
          .attr("y", function(d) { return y(d.y) + 6; });
    }

    function rect(rect) {
      rect.attr("x", function(d) { return x(d.x); })
          .attr("y", function(d) { return y(d.y); })
          .attr("width", function(d) { return x(d.x + d.dx) - x(d.x); })
          .attr("height", function(d) { return y(d.y + d.dy) - y(d.y); });
    }


  }

  render() {

    let treemapData = this.state.treemapData;

    if (!treemapData)
      return null;
    
    let playableElements = [];

    if (this.state.currentNode)
      playableElements = this.state.currentNode.children || this.state.currentNode._children;

    let type = 'artist';

    if (!this.state.isRoot)
      type = 'track';

    let url = '';

    if (this.state.isRoot)
      url = Element.url('user', {user: this.treemapSearchTerm()});
    else
      url = Element.url('artist', {artist: this.state.title});

    return (
      <div id="treemap">
        <div className="header">
          <h1><Link className="clickable" to={url}>{this.state.title}</Link></h1>
          <PlayButton elements={playableElements} type={type}/>
        </div>
        <svg ref="treemap" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision">
        </svg>
      </div>
    );



  }

}

export default Treemap;



// WEBPACK FOOTER //
// ./src/js/components/Treemap.jsx